// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"ac51882d46436c38f1382b96428090b021dbed243ea41609a1e0f819d99aee07","node_modules_react_index_js":"322dd505b94fc6c6f0343105da33504882dbd4ab7cf2f3e05c42087c11591e18"}[chunkId] + ".js";
};